import { StorySourceEnum, type StoryVideoModel } from '@/apiTypes/VideoTypes';
import { getCloudflareThumbUrl, getYoutubeThumbUrl } from '@/components/Video/unifiedVideoItems';

// Only Roadtrip Nation ships a poster. Null means the tile falls back to the player's first frame.
export const storyThumbUrl = (story: StoryVideoModel): string | null => {
    if (story.thumbUrl) {
        return story.thumbUrl;
    }
    if (story.source === StorySourceEnum.CLOUDFLARE_VIDEO && story.externalVideoUid) {
        return getCloudflareThumbUrl(story.externalVideoUid);
    }
    return getYoutubeThumbUrl(story.videoUrl);
};
